var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStickyFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "note-sticky-light 1",
    clipPath: "url(#clip0_164_709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.25 2.25C1.62773 2.25 1.125 2.75273 1.125 3.375V14.625C1.125 15.2473 1.62773 15.75 2.25 15.75H9.5625V12.375C9.5625 11.4434 10.3184 10.6875 11.25 10.6875H14.625V3.375C14.625 2.75273 14.1223 2.25 13.5 2.25H2.25ZM10.6875 15.2824L14.1574 11.8125H11.25C10.9406 11.8125 10.6875 12.0656 10.6875 12.375V15.2824ZM0 3.375C0 2.13398 1.00898 1.125 2.25 1.125H13.5C14.741 1.125 15.75 2.13398 15.75 3.375V10.8809C15.75 11.4785 15.5145 12.0516 15.0926 12.4734L11.3449 16.2176C10.923 16.6395 10.35 16.875 9.75234 16.875H2.25C1.00898 16.875 0 15.866 0 14.625V3.375Z",
    fill: "#898989"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.75,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickyFolder);
export default __webpack_public_path__ + "static/media/sticky_folder.89a9028353a9ff074bad8bf2500e200c.svg";
export { ForwardRef as ReactComponent };